import { useStaticFlags } from 'src/common/hooks/useStaticFlags/useStaticFlags';
import AddressSelector from './AddressSelector';
import AddressDisplay from '../AddressDisplay';

const AddressSelectorWrapper = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const { ENABLE_ADDRESS_CHANGE } = useStaticFlags();

  return ENABLE_ADDRESS_CHANGE ? (
    children || <AddressSelector />
  ) : (
    <AddressDisplay />
  );
};

export default AddressSelectorWrapper;
